// Imports

import React, { useState, useEffect, useRef ,useCallback} from "react";
import {
  Box,
  Button,
  Grid,
  Container,
  Modal,
  Typography,
  TextField,
  Checkbox,
  IconButton,
  Tooltip,
  Divider,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { Backdrop } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import jsPDF from "jspdf";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import CircularProgress from "@mui/material/CircularProgress";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import { CancelOutlined } from "@mui/icons-material";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";
import JoditEditor from "jodit-react";
import * as Yup from "yup";
import { confirmAlert } from "react-confirm-alert"; // Import
import Paper from "@mui/material/Paper";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Accordion from "@mui/material/Accordion";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";
import Moment from "moment";
import { useAlert } from "react-alert";
import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";
import ButtonGroup from "@mui/material/ButtonGroup";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { yupResolver } from "@hookform/resolvers/yup";
import InputAdornment from "@mui/material/InputAdornment";
import md5 from "md5";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import ReactQuill from "react-quill";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import SendIcon from "@mui/icons-material/Send";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
const PatientNote = (props) => {
  const editor = useRef(null);
  const [content, setContent] = useState("");
  const modules = {
    toolbar: [
      [{ font: [] }, { size: [] }], // Font and size
      ["bold", "italic", "underline", "strike"], // Text styles
      [{ color: [] }, { background: [] }], // Colors
      [{ script: "sub" }, { script: "super" }], // Sub/super script
      [{ header: 1 }, { header: 2 }], // Headers
      [{ list: "ordered" }, { list: "bullet" }, { list: "check" }], // Lists
      [{ indent: "-1" }, { indent: "+1" }], // Indentation
      [{ direction: "rtl" }], // Text direction
      [{ align: [] }], // Alignment
      ["link", "image", "video"], // Media
      ["blockquote", "code-block"], // Quotes & code
      ["clean"], // Remove formatting
    ],
  };

  const formats = [
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "script",
    "header",
    "list",
    "bullet",
    "indent",
    "direction",
    "align",
    "link",
    "image",
    "video",
    "blockquote",
    "code-block",
  ];

  const patientId = props.PatientId;

  const [submitting, setSubmitting] = useState(false);

  // API Authanticatiion
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };
  const navigate = useNavigate();
  const [rows, setRows] = useState("");
  const [Noteidrows, setNoteidrows] = useState("");
  const [isLoading, setLoading] = useState(false);
  // const [dos , setDos] = React.useState(Moment().format('YYYY-MM-DD'))
  const [patnoteid, setPatNoteId] = useState(0);
  const [noteetext, setnoteText] = useState("");
  const [noteetext1, setnoteText1] = useState("");
  const [patId, setPatId] = useState("");
  const [visidate, setVisitDate] = React.useState(Moment().format("YYYY-MM-DD"));
  const [refresh, setRefresh] = useState(false);
  const [temporarySelectedItems, setTemporarySelectedItems] = useState([]);
  // const handleCheckboxChange = (text, isChecked) => {
  //   setnoteText1((prev) => {
  //     const values = prev ? prev.split(',') : [];

  //     if (isChecked) {
  //       if (!values.includes(text.trim())) {
  //         return [...values, text.trim()].join(',');
  //       }
  //     } else {
  //       return values.filter((value) => value !== text.trim()).join(',');
  //     }
  //     return prev;
  //   });
  // };
  const handleCheckboxChange = (text, isChecked) => {
    setTemporarySelectedItems((prev) => {
      if (isChecked) {
        if (!prev.includes(text.trim())) {
          return [...prev, text.trim()];
        }
      } else {
        return prev.filter((item) => item !== text.trim());
      }
      return prev;
    });
  };
  const [openTemplate, setopenTemplate] = useState(false);

  const handleApply = () => {
    setnoteText1(temporarySelectedItems.join("<br/>"));
    setopenTemplate(false);
    setTemporarySelectedItems([]);
  };

  const handleOpenTemplate = () => {
    setopenTemplate(true);
  };
  const handleCloseTemplate = () => {
    setopenTemplate(false);
    setTemporarySelectedItems([]);
    setSearchText("");
  };

  const PatientId = props.PatientId;

  const [editorVisible, setEditorVisible] = useState(false);
  const [editorContent, setEditorContent] = useState("");

  const toggleEditor = () => {
    reset();
    setEditorVisible((prevVisible) => !prevVisible);
  };
  const UserName = localStorage.getItem("UserName");
  const [SignatureBY, setSignatureBY] = useState("");
  const [SignDate, setSignDate] = useState("");
  const [Sign, setSign] = useState("");

  const closeeditor = () => {
    setEditorVisible(false);
    setnoteText1("");
    setSignatureBY("");
    setSignDate("");
    setPatNoteId(0);
    setSign("");
    setVisitDate("");
  };
  // const handleEditorChange = (content) => {
  //   console.log("Content entered:", content);
  //   setValue("noteText", content);
  //   setnoteText(content);
  //   setnoteText1(content);
  // };
  
const handleEditorChange = useCallback(() => {
  if (!editor.current) return;
  const content = editor.current.innerHTML;
  setnoteText1(content);
}, []);

  const buttons = [
    { label: "B", cmd: "bold", style: { fontWeight: "bold" } },
    { label: "I", cmd: "italic", style: { fontStyle: "italic" } },
    { label: "U", cmd: "underline", style: { textDecoration: "underline" } },
    {
      label: "S",
      cmd: "strikeThrough",
      style: { textDecoration: "line-through" },
    },
    { label: "Sub", cmd: "subscript" },
    { label: "Sup", cmd: "superscript" },
    { label: "•", cmd: "insertUnorderedList" },
    { label: "1.", cmd: "insertOrderedList" },
    { label: "⯇", cmd: "justifyLeft" },
    { label: "≡", cmd: "justifyCenter" },
    { label: "⯈", cmd: "justifyRight" },
    { label: "☰", cmd: "justifyFull" },
    { label: "H1", cmd: "formatBlock", value: "h1" },
    { label: "H2", cmd: "formatBlock", value: "h2" },
    { label: "❝ ❞", cmd: "formatBlock", value: "blockquote" },
    { label: "{ }", cmd: "formatBlock", value: "pre" },
    { label: "🔗", cmd: "createLink", prompt: true },
  ];
  const [openAlert, setOpenAlert] = useState(false);
  const [cellid, setcellid] = useState("");
  const handleClickOpen = () => {
    setOpenAlert(true);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  //Modal
  const handleDeleteById = () => {
    const postData = {
      patientNoteId: cellid,
      deleted: true,
    };

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/PatientNote/AddPatientNote`,
        postData,
        {
          headers,
        },
      )
      .then((response) => {
        setRefresh(!refresh);
        setOpenAlert(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const validationSchema = Yup.object({
    visitDate: Yup.string().required("Visit Date is required"),
  });
  const style = {
    position: "absolute",
    top: "50%",
    left: "55%",
    transform: "translate(-50%, -50%)",
    width: 1000,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const checkstyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "60%",
    height: 500,
    maxHeight: "500px",
    bgcolor: "background.paper",
    border: "2px solid #377562",
    boxShadow: 24,
    padding: "5px",
    // zIndex: 10,
    overflowY: "auto",
  };
  const styleofmodal = {
    position: "absolute",
    top: "45%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "75vw",
    height: "80vh",
    bgcolor: "background.paper",
    border: "2px solid #377562",
    boxShadow: 24,
    p: 2,
    zIndex: 1700,
    overflowY: "auto",
  };
  useEffect(() => {
    setLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/PatientNote/getPatientNote?PatientId=${PatientId}`,
        {
          headers,
        },
      )
      .then((response) => {
        fields.forEach((field) => {
          setValue(field, response[field]);
        });
        setRows(response);
        setLoading(false);
      })

      .catch((error) => {
        console.error("There was an error!", error);
        setLoading(false);
      });
  }, [refresh, patId]);
  const [selectedRows, setSelectedRows] = useState([]);

  const columns = [
    {
      field: "Select",
      headerName: "Select",
      sortable: true,
      headerClassName: "super-app-theme--header",
      renderCell: (cellValues) => (
        <Checkbox
          color="primary"
          checked={selectedRows.includes(cellValues.row.id)}
          onClick={() => {
            if (selectedRows.includes(cellValues.row.id)) {
              // Remove if already selected
              setSelectedRows((prev) =>
                prev.filter((id) => id !== cellValues.row.id),
              );
            } else {
              // Add if not selected
              setSelectedRows((prev) => [...prev, cellValues.row.id]);
            }
          }}
        />
      ),
    },

    {
      field: "id",
      headerName: "ID",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 0.1,
      renderCell: (cellValues) => (
        <Button
          size="small"
          variant="text"
          color="info"
          style={{ float: "left", marginLeft: "-1.4rem" }}
          onClick={(event) => {
            setEditorVisible(true);
            var patientNoteId = cellValues.row.id;
            setPatNoteId(patientNoteId);
            axios
              .get(
                `${process.env.REACT_APP_API_URL}/PatientNote/getPatientNoteById?patientnoteid=${patientNoteId}`,
                {
                  headers,
                },
              )
              .then((response) => {
                if (response.length > 0) {
                  var res = response[0];
                  setNoteidrows(res);
                  setnoteText1(res.noteText);
                  var visiidate = Moment(res.visitDate).format("YYYY-MM-DD");
                  setVisitDate(visiidate);
                  // setValue("visitDate", visiidate);
                  setSignatureBY(res.signedBy);
                  // setSignDate(Moment(res.signedDate).format('YYYY-MM-DD HH:mm'));
                  const signDateValue = res.signedDate
                    ? Moment(res.signedDate).format("YYYY-MM-DD HH:mm")
                    : "";
                  setSignDate(signDateValue);
                  setSign(res.signed);
                }

                setLoading(false);
              })
              .catch((error) => {
                console.error("There was an error!", error);
                setLoading(false);
              });
          }}
        >{`${cellValues.row.id}`}</Button>
      ),
    },
    {
      field: "noteText",
      headerName: "Patient Notes",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 0.5,
      renderCell: (params) => {
        // Remove HTML tags from the noteText
        const plainText = params.value?.replace(/<[^>]+>/g, "") || "";
        return plainText;
      },
    },
    {
      field: "signed",
      headerClassName: "super-app-theme--header",
      headerName: "Signed",
      minWidth: 100,
      hide: false,
      renderCell: (params) =>
        params.row.signed ? (
          <Tooltip title="Note is Already Signed">
            <CheckIcon style={{ color: "green" }} />
          </Tooltip>
        ) : (
          <>
            <Tooltip title="Sign Note">
              <ClearIcon
                style={{ color: "red", cursor: "pointer" }}
                onClick={() => {
                  setnoteText1(params.row.noteText);
                  setVisitDate(params.row.visitDate);
                  setnoteText(params.row.noteText);
                  setPatNoteId(params.row.id);
                  setSignatureModalOpen(true);
                }}
              />
            </Tooltip>
          </>
        ),
    },
    {
      field: "signedBy",
      headerName: "Signed By",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 0.3,
    },
    {
      field: "signedDate",
      headerName: "Signed Date",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 0.3,
    },
    {
      field: "visitDate",
      headerName: "Visit Date",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 0.4,
    },
    {
      field: "deleted",
      headerName: "",
      sortable: true,
      headerClassName: "super-app-theme--header",
      minWidth: 0.5,
      renderCell: (cell) => (
        <>
          {props.Authorization !== "Authorization" ? (
            <DeleteIcon
              style={{
                marginRight: "5px",
                float: "right",
                marginTop: "5px",
                color: "red",
                cursor: "pointer",
                zIndex: 250000,
              }}
              onClick={() => {
                Swal.fire({
                  title: "Do you want to delete the record?",
                  text: "This action cannot be undone.",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#d33",
                  cancelButtonColor: "#3085d6",
                  confirmButtonText: "Yes",
                  cancelButtonText: "No",
                  target: document.querySelector("#hello-world"),
                }).then((result) => {
                  if (result.isConfirmed) {
                    const postData = {
                      patientNoteId: cell.row.id,
                      deleted: true,
                    };

                    axios
                      .post(
                        `${process.env.REACT_APP_API_URL}/PatientNote/AddPatientNote`,
                        postData,
                        {
                          headers,
                        },
                      )
                      .then((response) => {
                        setRefresh(!refresh);
                        Swal.fire({
                          title: "Deleted",
                          text: "Your file has been deleted.",
                          icon: "success",
                          timer: 1000,
                          showConfirmButton: false,
                          target: document.querySelector("#hello-world"),
                        });
                        // Handle any other actions after successful delete
                      })
                      .catch((error) => {
                        console.error("There was an error!", error);
                      });
                  }
                });
              }}
            />
          ) : (
            // 1111
            <>
              <Button
                onClick={() => {
                  handleClickOpen(cell);
                  setcellid(cell.row.id);
                }}
              >
                <DeleteIcon
                  color="black"
                  style={{
                    marginRight: "5px",
                    float: "right",
                    marginTop: "5px",
                    color: "red",
                    cursor: "pointer",
                    zIndex: 250000,
                  }}
                />
              </Button>
              <Dialog
                open={openAlert}
                onClose={handleCloseAlert}
                aria-labelledby="responsive-dialog-title"
                BackdropComponent={Backdrop}
                BackdropProps={{
                  invisible: true,
                }}
              >
                <DialogContent>
                  <DialogContentText style={{ color: "black" }}>
                    Do you want to delete the record?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={handleDeleteById}
                    style={{ background: "red", color: "white" }}
                    autoFocus
                  >
                    Yes
                  </Button>
                  <Button
                    autoFocus
                    onClick={handleCloseAlert}
                    style={{ color: "white", background: "#3085d6" }}
                  >
                    No
                  </Button>
                </DialogActions>
              </Dialog>
            </>
          )}
        </>
      ),
    },
  ];
  const PatientName = props.PatientName;
  const handleDownloadPDF = () => {
    const selectedData = rows.filter((r) => selectedRows.includes(r.id));
    selectedData.forEach((r) => {
      const doc = new jsPDF({
        orientation: "p",
        unit: "mm",
        format: "a4",
      });

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const currentDate = Moment().format("MMMM Do YYYY, h:mm A");
      const visitDate = r.visitDate
        ? Moment(r.visitDate).format("MMMM Do YYYY, h:mm A")
        : "N/A";

      // 🔹 Header
      const addHeader = () => {
        doc.setFontSize(16);
        doc.setFont("helvetica", "bold");
        const title = PatientName;
        doc.text(title, pageWidth / 2, 15, { align: "center" });

        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.text(`Note ID: ${r.id}`, pageWidth - 20, 15, { align: "right" });

        doc.setFontSize(9);
        doc.text(`Visit Date: ${visitDate}`, pageWidth / 2, 22, {
          align: "center",
        });
      };

      // 🔹 Footer
      const addFooter = () => {
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");

        // Signed Date - left
        doc.text(`Signed Date: ${r.signedDate || "N/A"}`, 15, pageHeight - 10, {
          align: "left",
        });

        // Signed By - right
        doc.text(
          `Signed By: ${r.signedBy || "N/A"}`,
          pageWidth - 15,
          pageHeight - 10,
          { align: "right" },
        );
      };

      // Add header
      addHeader();

      // 🔹 Note Content (html rendering to keep formatting <b>, <i>, etc.)
      const htmlContent = `
      <div style="font-size: 12px; font-family: Arial; line-height: 1.5; padding: 10px;">
        ${r.noteText}
      </div>
    `;

      doc.html(htmlContent, {
        callback: function (doc) {
          // Add footer *after* rendering
          addFooter();
          doc.save(`${PatientName || "Patient"}_Note_${r.id}.pdf`);
        },
        x: 15,
        y: 35,
        width: pageWidth - 30, // expand width
        windowWidth: 800,
      });
    });
  };
  const [openFax, setOpenFax] = useState(false);
  const [loadingFax, setLoadingFax] = useState(false);
  const [faxNumber, setFaxNumber] = useState("");
  const [faxSubject, setfaxSubject] = useState("");
  const handleOpenFax = () => {
    // 🔹 Check if all selected notes are signed
    const unsignedNotes = rows.filter(
      (r) => selectedRows.includes(r.id) && !r.signed,
    );

    if (unsignedNotes.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Unsigned Notes Detected",
        html: `
        Only <b>signed documents</b> are allowed to fax.<br><br>
        The following notes are unsigned:<br>
        <ul style="text-align:left; margin-top:10px;">
          ${unsignedNotes.map((n) => `<li>Note ID: ${n.id}</li>`).join("")}
        </ul>
      `,
        confirmButtonColor: "#d33",
        didOpen: () => {
          const swalEl = document.querySelector(".swal2-container");
          if (swalEl) swalEl.style.zIndex = "3000";
        },
      });
      return;
    }

    // ✅ All good — open the fax modal
    setOpenFax(true);
  };
  const handleCloseFax = () => {
    setFaxNumber("");
    setfaxSubject("");
    setSelectedRows([]);
    setOpenFax(false);
  };
  const [error, setError] = useState("");

  const handleFaxChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // remove all non-numeric characters
    setFaxNumber(value);

    if (value.length > 0 && value.length !== 10) {
      setError("Fax number must be exactly 10 digits");
    } else {
      setError("");
    }
  };
  const handleFaxSelectedNotes = async () => {
    const selectedData = rows.filter((r) => selectedRows.includes(r.id));

    try {
      setLoadingFax(true);

      const doc = new jsPDF({
        orientation: "p",
        unit: "mm",
        format: "a4", // ✅ same as handleDownloadPDF
      });

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      const currentDate = Moment().format("MMMM Do YYYY, h:mm A");

      // 🔹 Header (same style)
      const addHeader = () => {
        doc.setFontSize(16);
        doc.setFont("helvetica", "bold");
        const title = `${PatientName || "Patient"}'s SOAP / Progress Notes`;
        doc.text(title, pageWidth / 2, 15, { align: "center" });

        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.text(`Generated: ${currentDate}`, pageWidth / 2, 22, {
          align: "center",
        });
      };
      // 🧩 Combine all selected notes into one HTML block
      const combinedHTML = selectedData
        .map(
          (r, i) => `
        <div style="margin-bottom: 20px;">
          <h4 style="font-size: 12px; font-weight: bold; margin-bottom: 5px;">
            Note ${i + 1} (ID: ${r.id}) - ${
              r.visitDate
                ? Moment(r.visitDate).format("MMMM Do YYYY, h:mm A")
                : "N/A"
            }
          </h4>
          <div style="font-size: 12px; font-family: Arial; line-height: 1.5;">
            ${r.noteText || ""}
          </div>
        </div>
      `,
        )
        .join("<hr style='border:0.5px solid #ccc; margin:15px 0;'>");

      // 🔹 Add Header
      addHeader();

      // 🔹 Render combined notes
      await new Promise((resolve) => {
        doc.html(
          `
      <div style="font-size: 12px; font-family: Arial; line-height: 1.5; padding: 10px;">
        ${combinedHTML}
      </div>
    `,
          {
            callback: function (doc) {
              resolve();
            },
            x: 15,
            y: 35,
            width: pageWidth - 30,
            windowWidth: 800,
          },
        );
      });

      // ✅ Convert to Base64 (for API)
      const pdfBase64 = doc.output("datauristring");

      // ✅ Prepare API payload
      const payload = {
        faxNumber: `1${faxNumber}`, // assuming faxNumber state exists
        fileBase64: pdfBase64,
        subject: faxSubject || "Patient Notes",
        documentName: `${PatientName || "Patient"}_Notes.pdf`,
        FaxText: faxSubject || "",
      };

      console.log("📤 Sending Fax Payload:", payload);

      // ✅ POST to Fax API
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/Fax/UploadFax`,
        payload,
        { headers },
      );

      const apiResponse = response?.data || response;
      let errorMessage = "";

      if (apiResponse.portalResponse) {
        try {
          const parsed = JSON.parse(apiResponse.portalResponse);
          if (parsed.Status === "Failed") errorMessage = parsed.Result;
        } catch (err) {
          console.error("Error parsing portalResponse:", err);
        }
      }

      if (errorMessage) {
        Swal.fire({
          icon: "error",
          title: "Fax Failed",
          text: errorMessage,
          confirmButtonColor: "#d33",
        });
        return;
      }

      Swal.fire({
        icon: "success",
        title: "Fax Sent Successfully!",
        text: "Your fax has been sent.",
        timer: 1000,
        showConfirmButton: false,
      });

      handleCloseFax();
    } catch (error) {
      console.error("Fax sending failed:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error?.response?.data?.message ||
          "An unexpected error occurred while sending fax.",
        confirmButtonColor: "#d33",
      });
    } finally {
      setLoadingFax(false);
    }
  };

  const [ApiCall, setApiCall] = useState(false);
  const [TemplateRows, setTemplateRows] = useState(null);
  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/Template/getTemplateById`, {
        headers,
      })
      .then((response) => {
        setTemplateRows(response);
        setLoading(false);
      })
      .catch((error) => {});
  }, [ApiCall]);
  const gridRowStyle = {
    boxShadow: 2,
    border: 2,
    borderRadius: 2,
    background: "drak",
    fontSize: "13.4px !important",
    color: "drak !important",
    borderColor: "#326C1D",
    "& .MuiDataGrid-cell:hover": {
      color: "rgba(5, 152, 236, 0.637) !important",
      fontSize: "14.6px !important",
    },
    "& .super-app-theme--header": {
      backgroundColor: "#377562",
      borderRadius: 0.1,
      color: "white",
      fontSize: "16px !important",
    },
  };
  const fields = ["patientId", "visitDate", "noteText", "id"];

  const defValues = {
    id: 0,
    patientId: patientId,
    visitDate: "",
    noteText: "",
  };

  const {
    register,
    control,
    handleSubmit,
    setValue,
    reset,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
    context: undefined,
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
    delayError: undefined,
    resolver: yupResolver(validationSchema),
    defaultValues: defValues,
  });
  const alert = useAlert();

  const onSubmit = (data) => {
    if (submitting) return;
    if (!noteetext1 || noteetext1.trim() === "") {
      Swal.fire({
        icon: "error",
        title: "Note is empty",
        timer: 1000,
      });
      return;
    }
    setSubmitting(true);

    const postData = {
      ...data,
      patientId: patientId,
      patientNoteId: patnoteid,
      noteText: noteetext1, // Ensure this is the sanitized or correct content
      signedBy: SignatureBY,
      signedDate: SignDate,
      visitDate: visidate,
      signed: !!SignatureBY, // Simplified boolean check
    };

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/PatientNote/AddPatientNote`,
        postData,
        { headers },
      )
      .then((response) => {
        setSubmitting(false);
        closeeditor();
        setRefresh(!refresh);
        Swal.fire({
          icon: "success",
          timer: 1000,
          showConfirmButton: false,
          title: "Note saved successfully.",
          willOpen: () => {
            const container = document.querySelector(".swal2-container");
            if (container) container.style.zIndex = "1800";
          },
        });
      })
      .catch((error) => {
        setSubmitting(false);
        Swal.fire({
          icon: "error",
          title: `Error ${error.message}`,
          timer: 1000,
          willOpen: () => {
            const container = document.querySelector(".swal2-container");
            if (container) container.style.zIndex = "1800";
          },
        });
      });
  };
  function applyRefresh() {
    setRefresh(!refresh);
    // setOpen(false)
  }
  const [signatureModalOpen, setSignatureModalOpen] = useState(false);
  const [signUsername, setSignUsername] = useState(UserName);
  const [signPassword, setSignPassword] = useState("");
  const handleSignatureSubmit = async () => {
    if (!signUsername || !signPassword) {
      Swal.fire({
        icon: "warning",
        title: "Missing Information",
        text: "Please enter both username and password.",
        didOpen: () => {
          const swalPopup = document.querySelector(".swal2-popup");
          const swalContainer = document.querySelector(".swal2-container");
          if (swalPopup) swalPopup.style.zIndex = "2000";
          if (swalContainer) swalContainer.style.zIndex = "2000";
        },
      });
      return;
    }

    const loginData = {
      UserName: signUsername,
      password: md5(signPassword),
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/Users/login`,
        loginData,
        null,
      );

      if (response?.user.token) {
        const currentDate = Moment().format("YYYY-MM-DD HH:mm:ss");
        setSignatureBY(signUsername);
        setSignDate(currentDate);
        setSignatureModalOpen(false);
        setSignPassword("");

        Swal.fire({
          icon: "success",
          title: "Signed Successfully",
          text: `Signed by ${signUsername}`,
          timer: 1500,
          showConfirmButton: false,
          didOpen: () => {
            const swalPopup = document.querySelector(".swal2-popup");
            const swalContainer = document.querySelector(".swal2-container");
            if (swalPopup) swalPopup.style.zIndex = "2000";
            if (swalContainer) swalContainer.style.zIndex = "2000";
          },
        });
        const postData = {
          patientId: patientId,
          noteText: noteetext,
          visitDate: visidate,
          patientNoteId: patnoteid,
          signed: true,
          signedBy: signUsername,
          signedDate: currentDate,
        };

        await axios.post(
          `${process.env.REACT_APP_API_URL}/PatientNote/AddPatientNote`,
          postData,
          { headers },
        );

        setEditorVisible(false);
        setRefresh(!refresh);
        closeeditor();

        Swal.fire({
          icon: "success",
          title: "Note saved successfully.",
          timer: 1000,
          showConfirmButton: false,
          willOpen: () => {
            const container = document.querySelector(".swal2-container");
            if (container) container.style.zIndex = "1800";
          },
          onClose: () => {
            setEditorVisible(false);
          },
        });
      } else {
        throw new Error("Invalid credentials");
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Login Failed",
        text: "Invalid username or password.",
        didOpen: () => {
          const swalPopup = document.querySelector(".swal2-popup");
          const swalContainer = document.querySelector(".swal2-container");
          if (swalPopup) swalPopup.style.zIndex = "2000";
          if (swalContainer) swalContainer.style.zIndex = "2000";
        },
      });
    }
  };
  const [searchText, setSearchText] = useState("");

  const filterTemplates = (templates, searchTerm) => {
    if (!searchTerm) return templates;
    return templates.filter(
      (row) =>
        row.text?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        row.name?.toLowerCase().includes(searchTerm.toLowerCase()),
    );
  };

  const getHighlightedText = (text, highlight) => {
    if (!highlight) return text;
    const parts = text.split(new RegExp(`(${highlight})`, "gi"));
    return parts.map((part, i) =>
      part.toLowerCase() === highlight.toLowerCase() ? (
        <span key={i} style={{ backgroundColor: "yellow" }}>
          {part}
        </span>
      ) : (
        part
      ),
    );
  };

  return (
    <div>
      <Dialog
        open={openFax}
        onClose={handleCloseFax}
        maxWidth="xs"
        sx={{ zIndex: 1760 }}
        fullWidth
        PaperProps={{
          sx: { borderRadius: 3, p: 1 },
        }}
      >
        {/* Header Section */}
        <Box display="flex" alignItems="center" gap={1.5} sx={{ px: 2, pt: 2 }}>
          <LocalPrintshopIcon color="primary" fontSize="large" />
          <Box>
            <Typography variant="h6" fontWeight={600}>
              Send Fax
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Enter the recipient fax number below.
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ my: 1 }} />

        {/* Fax Input Section */}
        <DialogContent>
          <TextField
            label="Fax Number"
            fullWidth
            margin="dense"
            value={faxNumber}
            onChange={handleFaxChange}
            placeholder="Enter 10-digit fax number"
            inputProps={{ maxLength: 10 }}
            InputLabelProps={{ shrink: true }}
            error={!!error}
            helperText={error}
          />
          <TextField
            label="Fax Subject"
            fullWidth
            margin="dense"
            placeholder="Enter Fax Subject"
            value={faxSubject}
            InputLabelProps={{ shrink: true }}
            onChange={(e) => setfaxSubject(e.target.value)}
          />
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleCloseFax} color="secondary" variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={handleFaxSelectedNotes}
            color="primary"
            variant="contained"
            endIcon={<SendIcon />}
            disabled={loadingFax}
          >
            Send Fax
          </Button>
        </DialogActions>
      </Dialog>
      <Grid container>
        <Grid item xs={12}>
          <Grid item spacing={1} xs={12} sm={12} md={12} lg={12}>
            <Box display="flex" justifyContent="flex-end">
              <ButtonGroup aria-label="outlined primary button group">
                <Button
                  className="Button"
                  variant="contained"
                  onClick={toggleEditor}
                >
                  <AddOutlinedIcon
                    fontSize="small"
                    style={{
                      color: "white",
                      paddingRight: "4px",
                      paddingBottom: "2px",
                    }}
                  ></AddOutlinedIcon>
                  Add New
                </Button>
                <Button
                  className="Button"
                  variant="contained"
                  onClick={(event) => {
                    applyRefresh();
                  }}
                  style={{ marginLeft: "1rem" }}
                >
                  <CachedOutlinedIcon
                    fontSize="small"
                    style={{
                      color: "white",
                      marginRight: "1px",
                      paddingRight: "0px",
                      paddingBottom: "1px",
                    }}
                  ></CachedOutlinedIcon>
                  Refresh
                </Button>
                <Button
                  className="Button"
                  variant="contained"
                  disabled={selectedRows.length === 0}
                  onClick={handleDownloadPDF}
                  style={{ marginLeft: "1rem" }}
                >
                  <DownloadOutlinedIcon
                    fontSize="small"
                    style={{
                      color: "white",
                      // marginLeft: '20px',
                      paddingBottom: "2px",
                    }}
                  ></DownloadOutlinedIcon>
                  Download Select Notes
                </Button>
                <Button
                  className="Button"
                  variant="contained"
                  disabled={selectedRows.length === 0}
                  onClick={handleOpenFax}
                  style={{ marginLeft: "1rem" }}
                >
                  <LocalPrintshopOutlinedIcon
                    fontSize="small"
                    style={{
                      color: "white",
                      // marginLeft: '20px',
                      paddingBottom: "2px",
                    }}
                  ></LocalPrintshopOutlinedIcon>
                  Fax Selected Notes
                </Button>
              </ButtonGroup>
            </Box>
          </Grid>
          <>
            <Box mb={3} marginTop={2}>
              {isLoading ? (
                <div style={{ margin: "5rem", textAlign: "center" }}>
                  <CircularProgress />
                </div>
              ) : (
                <div style={{ height: 400, width: "100%" }}>
                  {rows === null || rows.length === 0 ? (
                    <Typography>No Record found</Typography>
                  ) : (
                    <DataGrid
                      rows={rows}
                      rowHeight={28}
                      columns={columns}
                      headerHeight={28}
                      sx={gridRowStyle}
                      pagination
                      autoPageSize
                    />
                  )}
                </div>
              )}
            </Box>
          </>
        </Grid>
      </Grid>
      <Modal
        open={openTemplate}
        onClose={handleCloseTemplate}
        sx={{ zIndex: 1800 }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 700,
            bgcolor: "background.paper",
            boxShadow: 24,
            height: "470px",
            p: 4,
            borderRadius: 2,
            overflowY: "auto",
          }}
        >
          <Grid
            container
            style={{
              backgroundColor: "#356F60",
              position: "sticky",
              borderRadius: "8px",
            }}
          >
            <Grid item xs={12}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  height: "3rem",
                  padding: "8px",
                }}
              >
                <h1
                  style={{
                    fontWeight: "bold",
                    margin: 0,
                    color: "#fff",
                    textDecoration: "underline",
                    fontSize: "1.2rem",
                  }}
                >
                  Templates
                </h1>

                <IconButton
                  onClick={handleCloseTemplate}
                  style={{
                    color: "red",
                    backgroundColor: "rgba(255, 77, 77, 0.1)",
                    borderRadius: "50%",
                    transition: "all 0.3s ease",
                  }}
                >
                  <CancelOutlined fontSize="medium" />
                </IconButton>
              </div>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12}>
              <Typography sx={{ fontWeight: "bold" }}>
                Search Templates
              </Typography>
              <TextField
                variant="outlined"
                placeholder="Search Templates..."
                size="small"
                fullWidth
                sx={{ backgroundColor: "white", borderRadius: 1 }}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </Grid>
          </Grid>
          <>
            {/* {TemplateRows != null && TemplateRows.length > 0 ? (
            TemplateRows.map((row) => ( */}
            {/* {TemplateRows != null && TemplateRows.length > 0 ? (
            TemplateRows
              .filter((row) =>
                row.text
                  ?.replace(/<[^>]+>/g, '')  // remove HTML tags
                  .toLowerCase()
                  .includes(searchTerm.toLowerCase())
              )
              .map((row) => (

                <Paper
                  variant="outlined"
                  square
                  style={{
                    backgroundColor: '#F0F6F8',
                    borderRadius: '15px',
                    marginTop: '5px',
                    borderColor: '#377562',
                    padding: '.9rem',
                  }}
                  key={row.id}
                >
                  <Grid container >
                    <Grid item xs={1} >
                      <Checkbox
                        onChange={(e) =>
                          handleCheckboxChange(row.text.trim(), e.target.checked)
                        }

                      />
                    </Grid>
                    <Grid item xs={9} mt={1}>
                      <Typography
                        style={{
                          fontWeight: 400,
                          color: 'black',
                          borderRadius: '8px',
                        }}
                      >
                        <b>{row.name}</b>
                      </Typography>
                    </Grid>
                    <Grid item xs={11}  >
                    
                      {row.text?.split(/(\|\|\||,)/).filter(item => item !== '|||' && item !== ',').map((text, textIndex) => (

                        <Grid
                          container
                          margin={'3px'}
                          justifyContent="space-between"
                          key={`${row.id}-${textIndex}`}
                        >
                          {/* <Grid item xs={1} >
                        <Checkbox
                          onChange={(e) =>
                            handleCheckboxChange(text.trim(), e.target.checked)
                          }

                        />
                      </Grid> 
                          <Grid item xs={0.5}>
                            <Box
                              style={{
                                width: '28px',
                                height: '28px',
                                backgroundColor: '#E9E9EE',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                            >
                              <Typography>{textIndex + 1}</Typography>
                            </Box>
                          </Grid>
                          <Grid
                            item
                            xs={9}
                            style={{ textAlign: 'left' }}
                          >
                            <Typography style={{ cursor: 'pointer' }}>
                              {text.replace(/<[^>]+>/g, '')}
                            </Typography>
                          </Grid>
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                </Paper>
              ))
          ) : (
            'No Templates Found'
          )} */}
          </>
          {TemplateRows != null && TemplateRows.length > 0 ? (
            filterTemplates(TemplateRows, searchText).map((row) => (
              <Paper
                variant="outlined"
                square
                sx={{
                  backgroundColor: "#F0F6F8",
                  // bgcolor: 'background.paper',
                  borderRadius: "15px",
                  marginTop: "10px",
                  borderColor: "#377562",
                  p: 2,
                }}
                key={row.id}
              >
                <Accordion
                  elevation={0}
                  disableGutters
                  sx={{ background: "#F0F6F8" }}
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Grid container spacing={1} alignItems="center">
                      <Grid item xs={1}>
                        <Checkbox
                          onChange={(e) =>
                            handleCheckboxChange(
                              row.text.trim(),
                              e.target.checked,
                            )
                          }
                        />
                      </Grid>
                      <Grid item xs={11}>
                        <Typography fontWeight={600} gutterBottom>
                          {getHighlightedText(row.name, searchText)}
                        </Typography>
                      </Grid>
                    </Grid>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={1}>
                      {/* {row.text?.split(/(\|\|\||,)/).filter(item => item !== '|||' && item !== ',').map((text, textIndex) => ( */}
                      {row.text?.split("|||").map((text, textIndex) => (
                        <Grid
                          container
                          marginY={0.5}
                          justifyContent="flex-start"
                          key={`${row.id}-${textIndex}`}
                        >
                          <Grid item xs={1}>
                            <Box
                              style={{
                                width: "28px",
                                height: "28px",
                                backgroundColor: "#E9E9EE",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Typography>{textIndex + 1}</Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={11}>
                            <Typography>
                              {getHighlightedText(
                                text.replace(/<[^>]+>/g, ""),
                                searchText,
                              )}
                            </Typography>
                          </Grid>
                        </Grid>
                      ))}
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </Paper>
            ))
          ) : (
            <Typography mt={2} textAlign="center">
              No Templates Found
            </Typography>
          )}
          <Grid item xs={12} mb={2}>
            <Button
              className="Button"
              onClick={handleApply}
              variant="gradient"
              style={{
                marginBottom: "10px",
                marginTop: "5px",
                marginRight: "20px",
                float: "right",
                width: "100px",
                height: "35px",
                color: "white",
                fontSize: "14px",
              }}
            >
              Apply
            </Button>
          </Grid>
        </Box>
      </Modal>
      {editorVisible && (
        <Box sx={styleofmodal}>
          <Grid container spacing={0}>
            <Grid
              container
              style={{
                fontWeight: 500,
                backgroundColor: "#377562",
                padding: "4px",
                borderRadius: "8px",
              }}
            >
              <Grid item xs={11}>
                <Typography
                  style={{
                    fontWeight: "bold",
                    fontSize: "22px",
                    color: "white",
                  }}
                >
                  Add Notes
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <CancelOutlined
                  onClick={closeeditor}
                  fontSize="large"
                  style={{
                    color: "red",
                    float: "right",
                    marginTop: "2px",

                    // marginRight: "-30px",
                    // cursor: 'pointer'
                  }}
                ></CancelOutlined>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography style={{ fontWeight: "bold", color: "black" }}>
                DOS
              </Typography>
              <Controller
                name="visitDate"
                {...register("visitDate")}
                control={control}
                render={({ field }) => (
                  <TextField
                    size="small"
                    fullWidth
                    type="date"
                    value={visidate}
                    onChange={(e) => {
                      setValue("visitDate", e.target.value);
                      setVisitDate(e.target.value);
                    }}
                    error={!!errors.visitDate}
                    helperText={errors.visitDate?.message}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} p={2} alignContent={"right"}>
              {patnoteid <= 0 && (
                <Button
                  className="Button"
                  variant="contained"
                  disabled={Sign}
                  onClick={handleOpenTemplate}
                >
                  <AddOutlinedIcon
                    fontSize="small"
                    style={{
                      color: "white",
                      paddingRight: "4px",
                      paddingBottom: "2px",
                      float: "right",
                    }}
                  ></AddOutlinedIcon>
                  Add Template
                </Button>
              )}
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12}>
              {/* <div style={{ width: "100%", height: 320, overflow: 'auto' }}> 
                   <JoditEditor
                    ref={editor}
                    value={noteetext1}
                    onChange={handleEditorChange}
                    error={errors.noteText ? 'Note Is Empty' : ''}
                    helperText={errors.noteText ? 'Note Is Empty' : 'Note Is Empty'}
                    readonly={Sign === true}
                    config={{ height: 300 }}
                  />
                </div>
                {noteetext1.length == 0 && <p style={{ color: 'red' }}>Note Is Empty</p>} */}
              {/* <ReactQuill
                value={noteetext1}
                onChange={handleEditorChange}
                modules={modules}
                formats={formats}
                theme="snow"
                style={{
                  backgroundColor: "white",
                  borderRadius: "5px",
                  height: "300px", // full container height
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                }}
              /> */}
              {/* <style>
                {`
    .ql-toolbar {
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
    }

    .ql-container {
      flex: 1; 
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      overflow-y: auto;
    }

    .ql-editor {
      height: 100%;
      padding: 10px;
    }
  `}
              </style> */}
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 0.5,
                  p: 1,
                  backgroundColor: "#f5f6f8",
                  borderBottom: "1px solid #ddd",
                  top: 0,
                  zIndex: 10,
                }}
              >
                {buttons.map((btn) => (
                  <Button
                    key={btn.label}
                    size="small"
                    onMouseDown={(e) => {
                      e.preventDefault();
                      editor.current?.focus();

                      let value = null;
                      if (btn.prompt) {
                        const url = prompt("Enter URL");
                        if (url) value = url;
                      } else if (btn.value) {
                        value = btn.value;
                      }

                      document.execCommand(btn.cmd, false, value);

                      // Update state after execCommand
                      // handleEditorChange(editor.current.innerHTML);
                      handleEditorChange();
                    }}
                    sx={{
                      minWidth: 34,
                      height: 30,
                      px: 1,
                      fontSize: 12,
                      borderRadius: "6px",
                      border: "1px solid #ccc",
                      backgroundColor: "#fff",
                      color: "#333",
                      ...btn.style,
                      "&:hover": {
                        backgroundColor: "#e3f2fd",
                        borderColor: "#90caf9",
                      },
                    }}
                  >
                    {btn.label}
                  </Button>
                ))}
              </Box>

              {/* Editor */}
              <div
                ref={editor}
                contentEditable
                suppressContentEditableWarning
                style={{
                  height: "250px",
                  border: "none",
                  borderRadius: "0 0 6px 6px",
                  padding: "16px",
                  fontFamily: "'Calibri', 'Segoe UI', sans-serif",
                  fontSize: 14,
                  border: "1px solid #ccc",
                  backgroundColor: "#fff",
                  overflowY: "auto",
                }}
                onBlur={handleEditorChange}
                dangerouslySetInnerHTML={{ __html: noteetext1 }}
              />

              {/* 
              {noteetext1.length == 0 && (
                <p style={{ color: "red" }}>Note Is Empty</p>
              )} */}
            </Grid>

            <Grid item xs={12}>
              {!SignatureBY && patnoteid > 0 && (
                <Button
                  variant="outlined"
                  startIcon={<BorderColorIcon />}
                  onClick={() => setSignatureModalOpen(true)}
                  style={{
                    color: "#356F60",
                    borderColor: "#356F60",
                    marginBottom: "10px",
                    fontWeight: 600,
                  }}
                >
                  Sign Note
                </Button>
              )}

              {SignatureBY && (
                <Box
                  mt={1}
                  sx={{
                    border: "1px solid #ccc",
                    borderRadius: 2,
                    p: 2,
                    backgroundColor: "#f9f9f9",
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{ color: "#2f5e51", fontFamily: "Cursive" }}
                  >
                    {SignatureBY}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#777" }}>
                    Signed on: {SignDate}
                  </Typography>
                </Box>
              )}
            </Grid>

            <Grid item xs={12}>
              <Button
                className="Button"
                onClick={handleSubmit(onSubmit)}
                variant="gradient"
                disabled={submitting || Sign}
                style={{
                  // marginTop: "100px",
                  marginBottom: "10px",
                  marginTop: "5px",
                  marginRight: "20px",
                  float: "right",
                  // marginLeft: "890px",
                  width: "80px",
                  height: "35px",
                  // backgroundColor: "#A574FD",
                  color: "white",
                  fontSize: "14px",
                }}
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </Box>
      )}
      <Container>
        {/* <Box mb={3} margin={3}>
          {isLoading ? (
            <div style={{ margin: "5rem", textAlign: "center" }}>
              <CircularProgress />
            </div>
          ) : (
            <> */}
        {/* <div style={{ height: 400, width: "100%" }}>
                {rows === null || rows.length === 0 ? (
                  "No Record Found"
                ) : (
                  <DataGrid
                    rows={rows}
                    rowHeight={28}
                    columns={columns}
                    headerHeight={28}
                    sx={gridRowStyle}
                    pagination
                    autoPageSize
                  />
                )}
              </div> */}
        {/* 
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                  <CancelOutlined
                    onClick={handleClose}
                    style={{
                      float: "right",
                      color: "red",
                      marginTop: "-30px",
                      cursor: "pointer",
                      marginRight: "-20px",
                    }}
                  ></CancelOutlined>
                  <div style={{ height: 400, width: "100%" }}>
                    {Noteidrows === null || Noteidrows.length === 0 ? (
                      "No Record Found"
                    ) : (
                      <DataGrid
                        rows={Noteidrows}
                        rowHeight={28}
                        columns={PatientNotecolumns}
                        headerHeight={28}
                        PatientSize={5}
                        rowsPerPatientOptions={[5]}
                        sx={gridRowStyle}
                      />
                    )}
                  </div>
                </Box>
              </Modal> */}
        {/* </>
          )} */}
        {/* </Box> */}
      </Container>
      <Modal
        open={signatureModalOpen}
        onClose={() => setSignatureModalOpen(false)}
        sx={{ zIndex: 1800 }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 2,
            p: 0,
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              backgroundColor: "#377562",
              color: "white",
              px: 2,
              py: 1.5,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", color: "#fff " }}
            >
              Sign Note
            </Typography>
            <CancelOutlined
              onClick={() => setSignatureModalOpen(false)}
              sx={{ cursor: "pointer", color: "white" }}
            />
          </Box>

          {/* Content */}
          <Box sx={{ p: 3 }}>
            <TextField
              label="Username"
              fullWidth
              value={signUsername}
              onChange={(e) => setSignUsername(e.target.value)}
              InputProps={{
                readOnly: true,
              }}
              margin="normal"
            />

            <TextField
              label="Password"
              type="password"
              fullWidth
              value={signPassword}
              onChange={(e) => setSignPassword(e.target.value)}
              margin="normal"
            />

            <Box mt={2} display="flex" justifyContent="flex-end" gap={2}>
              <Button
                variant="outlined"
                onClick={() => setSignatureModalOpen(false)}
              >
                Cancel
              </Button>
              <Button variant="contained" onClick={handleSignatureSubmit}>
                Save
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default PatientNote;
